module.exports = __webpack_public_path__ + "static/910-00522394b90db010ed5f461db9e5daaa.png";